import React from 'react';
import { trackEvent } from '../../utils/analytics';
import '../../styles/components/RepoCard.css';

/**
 * One GitHub-style repository card. Click → opens the repo in a new
 * tab. Fires `repo_card_clicked` so we can see which repos recruiters
 * actually open.
 *
 * The lock-icon path exists for any future private cards we want
 * to show without a link; for now it's unused (we excluded private
 * repos from v1).
 */
const RepoCard = ({ name, description, language, languageColor, updated, url, isPrivate = false }) => {
    const handleClick = () => {
        if (isPrivate || !url) return;
        trackEvent('repo_card_clicked', { repo: name });
    };

    const CardWrapper = isPrivate || !url ? 'div' : 'a';
    const wrapperProps = isPrivate || !url
        ? {}
        : {
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
              onClick: handleClick,
          };

    return (
        <CardWrapper className={`RepoCard ${isPrivate ? 'RepoCard--private' : ''}`} {...wrapperProps}>
            <div className="RepoCard__header">
                <svg className="RepoCard__icon" viewBox="0 0 16 16" aria-hidden="true">
                    <path fillRule="evenodd" d="M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5v-9zm10.5-1V9h-8c-.356 0-.694.074-1 .208V2.5a1 1 0 0 1 1-1h8zM5 12.25v3.25a.25.25 0 0 0 .4.2l1.45-1.087a.25.25 0 0 1 .3 0L8.6 15.7a.25.25 0 0 0 .4-.2v-3.25a.25.25 0 0 0-.25-.25h-3.5a.25.25 0 0 0-.25.25z" />
                </svg>
                <span className="RepoCard__name">{name}</span>
                {isPrivate && (
                    <span className="RepoCard__badge" aria-label="Private repository">
                        Private
                    </span>
                )}
            </div>

            {description && <p className="RepoCard__description">{description}</p>}

            <div className="RepoCard__meta">
                {language && (
                    <span className="RepoCard__lang">
                        <span
                            className="RepoCard__lang-dot"
                            style={{ background: languageColor || '#6b7280' }}
                            aria-hidden="true"
                        />
                        {language}
                    </span>
                )}
                {updated && <span className="RepoCard__updated">Updated {updated}</span>}
            </div>
        </CardWrapper>
    );
};

export default RepoCard;
